<ul class="renci-validation" *ngIf="errors.length">
  <li *ngFor='let error of errors'>
    {{ error }}
  </li>
</ul>
